<template>

 <!-- v-if="$_.size(colis)" -->
<div :class="'row relative-position square q-mt-lg'+( bordered ? ' borders' : '')" :style="styles">
    <q-card class="col-12" flat bordered square>


        <q-list dense separator bordered><!--  class="border-left border-right" -->

            <q-item dense v-if="(!isProd || isMaster) && colis.id">
                <q-item-section avatar class="normal"><q-item-label caption>ID</q-item-label></q-item-section>
                <q-item-section><q-item-label>{{ colis.id }}</q-item-label></q-item-section>
            </q-item>

            <q-item v-if=" ! colis.id">
                <q-item-section><q-item-label overline class="text-warning text-bold">Colis Non Enregistré</q-item-label></q-item-section>
            </q-item>

            <q-item :clickable="Boolean(colis.id)" @click.stop="colis_state.itemForPhotos = colis; colis_state.openModalPhotos = true"
                     :disable="Boolean( ! colis.id)">
                <q-item-section avatar><q-icon name="add_a_photo" color="teal-6" /></q-item-section>
                <q-item-section>
                    <q-item-label><b v-if="$_.size(colis.files)">{{ pluralize($_.size(colis.files), 'Photo') }}</b><span v-else>Prendre des Photos</span></q-item-label>
                    <q-item-label caption v-if=" ! colis.id"><small class="text-info">Vous pourrez y associer des photos une fois enregistré</small></q-item-label>
                </q-item-section>
            </q-item>

            <q-item dense v-if="showed('ref')">
                <q-item-section avatar class="normal"><q-item-label caption><i>Référence</i></q-item-label></q-item-section>
                <q-item-section class="q-mr--sm">
                    <q-btn icon-right="content_copy" :label="colis.ref" @click="copyToClipboard(colis.ref, 'Référence Colis')" dense outline square size="md" no-caps style="max-width:300px" />
                </q-item-section>
            </q-item>
            <q-item dense v-if="showed('status_current')">
                <q-item-section avatar class="normal"><q-item-label caption><i>Statut</i></q-item-label></q-item-section>
                <q-item-section>
                    <q-item-label :class="'text-'+(!colis.deleted_at ? colis.status_current.color : 'grey-8')">
                        <q-icon :name="colis.status_current.icon" :color="(!colis.deleted_at ? colis.status_current.color : 'grey-8')" left />
                        {{ colis.status_current.str }}
                    </q-item-label>
                    <q-item-label caption><!--  v-if="colis.status_current.date" -->
                        <StatusDates :item="colis.status_current" />
                    </q-item-label>
                </q-item-section>
            </q-item>
            <q-item dense v-if="showed('recipient')">
                <q-item-section avatar class="normal"><q-item-label caption><i>Expéditeur</i></q-item-label></q-item-section>
                <q-item-section><q-item-label>{{ colisStore().getShopLabel(colis) }}</q-item-label></q-item-section>
                <q-item-section side v-if="isCarrier"><q-btn icon="visibility" @click="link(route('shop.edit', colis.shop?.id))" dense outline square size="sm" color="info" /></q-item-section>
            </q-item>
            <q-item dense v-if="showed('recipient')">
                <q-item-section avatar class="normal"><q-item-label caption><i>Destinataire</i></q-item-label></q-item-section>
                <q-item-section><q-item-label>{{ colisStore().getRecipientLabel(colis) }}</q-item-label></q-item-section>
                <q-item-section side v-if="isCarrier"><q-btn icon="visibility" @click="link(route('recipient.edit', colis.recipient?.id))" dense outline square size="sm" color="info" /></q-item-section>
            </q-item>

            <q-item dense v-if="showed('nature')">
                <q-item-section avatar class="normal"><q-item-label caption><i>Nature de la<br/>marchandise</i></q-item-label></q-item-section>
                <q-item-section><q-item-label>{{ colis.nature || '?' }}</q-item-label></q-item-section>
            </q-item>
            <q-item dense v-if="showed('qty')">
                <q-item-section avatar class="normal"><q-item-label caption><i>Quantité de<br/>marchandise</i></q-item-label></q-item-section>
                <q-item-section><q-item-label>{{ colis.qty || '?' }}</q-item-label></q-item-section>
            </q-item>
            <q-item dense v-if="showed('value')">
                <q-item-section avatar class="normal"><q-item-label caption><i>Valeur<br/>Estimée</i></q-item-label></q-item-section>
                <q-item-section><q-item-label>{{ colis.value || '-' }} €</q-item-label></q-item-section>
            </q-item>
            <q-item dense v-if="showed('poids')">
                <q-item-section avatar class="normal"><q-item-label caption><i>Poids</i></q-item-label></q-item-section>
                <q-item-section><q-item-label>{{ colis.poids || '?' }} Kg</q-item-label></q-item-section>
            </q-item>
        </q-list>

    <slot></slot>



    <q-card-actions align="left" v-if="showLink" class="q-animate--fade">

        <q-btn icon="visibility" color="info"  dense square size="md" style="z-index:9"
                @click="link(route('colis.show', colis.id))" />

    </q-card-actions>

    </q-card>
</div>


<Photos v-if="colis.id && colis_state.openModalPhotos && colis_state.itemForPhotos && (colis_state.itemForPhotos?.id == colis.id)"
            :item="colis_state.itemForPhotos" />


</template>

<script setup>
import { link, formatDate, nl2br, strLimit, copyToClipboard, pluralize } from "@helpers";
import { colisStore, editionStore } from "@stores";

import Photos from "@page/Colis/partials/Photos.vue";
import StatusDates from "@page/Course/partials/StatusDates.vue";

const props  = defineProps({
    colis: Object,
    omit: Array,
    'show-link': Boolean,
    bordered: Boolean,
    styles: String, // if errors (from Course Edit|Create)
})

const colis_state = colisStore().$state

const showed = (col)=>{
    if(!_.size(props.omit) && (props.colis[col] || props.colis[col] === 0/*0: pour les status*/) ){ return true; }

    return ! _.includes(props.omit, col) && (props.colis[col] || props.colis[col] === 0/*0: pour les status*/)
}
</script>
